// extracted by mini-css-extract-plugin
export default {"container":"Gj-z","blurb":"Hj-z","links":"Ij-z"};